import request from '@/utils/request'

const api_name = '/api/water-source'

export default {

  getPageList(page, limit,searchObj) {
    return request({
      url: `${api_name}/water-source-list/${page}/${limit}`,
      method: 'get',
      params: searchObj
    })
  },
  getQmapByKeyword(keyword) {
    return request({
      url: `${api_name}/get-qq-map-list?keyword=${keyword}`,
      method: 'get'
    })
  },
  getAll(searchObj) {
    return request({
      url: `${api_name}/all-water-source`,
      method: 'get',
      params: searchObj
    })
  },
  export(searchObj) {
    return request({
      url: `${api_name}/export`,
      method: 'get',
      params: searchObj
    })
  },
  removeById(id) {
    return request({
      url: `${api_name}/remove-water-source/${id}`,
      method: 'delete'
    })
  },
  saveSubject(subject) {
    return request({
      url: `${api_name}/save-water-source`,
      method: 'post',
      data: subject
    })
  },
  updateById(subject) {
    return request({
      url: `${api_name}/update-water-source`,
      method: 'put',
      data: subject
    })
  },
  updateVersion(subject) {
    return request({
      url: `${api_name}/update-water-source-version`,
      method: 'put',
      data: subject
    })
  },
  getById(id) {
    return request({
      url: `${api_name}/get-water-source/${id}`,
      method: 'get'
    })
  },
  statisticsByUnit(searchObj) {
    return request({
      url: `${api_name}/statistics-water-source-unit`,
      method: 'get',
      params: searchObj
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/waterSource.js